// extracted by mini-css-extract-plugin
module.exports = {"container":"_22TiX_408VOW5q8Nrc87Kn","avatar":"muZLet7qCACEMuBtQGE4-","agent-container":"NDt1nJXzq377NQrwZz6yZ"};